var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Opaque",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 8,
    cx: 60,
    cy: 36,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 8,
    cx: 36,
    cy: 60,
    r: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.13cb8353320686073f73d75e0f4a9ee7.svg";
export { ForwardRef as ReactComponent };